'use client';

import { CollectionType } from '@/@types';
import clsx from 'clsx';
import InternalLink from '@/components/core/components/organism/internal-link';
import ContentLoader from 'react-content-loader';
import theme from '@/components/core/theme';
import { Trans } from '@lingui/react/macro';
import { useLocalizedLinks } from '@/components/core/hooks';
import { UIComponent } from '../..';
import { Avatar, Element, Icon } from '../../atoms';
import CollectionLogo from '../collection-logo';
import * as styles from './collection-card.styles';

const CollectionCard: UIComponent<
  { size?: number | string; collection?: CollectionType; loader?: boolean; vertical?: boolean; hideOwner?: boolean },
  'a'
> = ({ collection, loader, className, vertical, hideOwner, size, ...props }) => {
  const links = useLocalizedLinks();

  if (loader || !collection) {
    return (
      <div className={clsx(styles.root, className, { [styles.vertical]: vertical })}>
        <CollectionLogo size={size} />
        <div className={clsx(styles.info, 'flex-1')}>
          <ContentLoader viewBox="0 0 200 100" foregroundColor={theme.colors.peoople['gris-medio']}>
            <rect x="0" y="35" width="150" height="4" />
            <circle cx="10" cy="55" r="10" />
            <rect x="30" y="55" width="60" height="4" />
          </ContentLoader>
        </div>
      </div>
    );
  }
  return (
    <InternalLink href={links.collection(collection)} {...props} className={clsx(styles.root, className, { [styles.vertical]: vertical })}>
      <CollectionLogo size={size} collection={collection} className={styles.logo} />
      <div className={styles.info}>
        <Element className={styles.title} lines={1}>
          {collection.isPrivate && <Icon name="lock" />} {collection.name}
        </Element>
        {(collection.content?.total || 0) > 0 && (
          <Element lines={1} className={styles.count}>
            <Trans>{collection.content?.total} recommendations</Trans>
          </Element>
        )}
        {collection.owner && (
          <Element
            lines={1}
            className={clsx(styles.subtitle, {
              hide: hideOwner,
              flex: !hideOwner,
            })}
          >
            <Avatar src={collection.owner?.avatar} size={24} level={collection.owner.level?.name} />
            <Element lines={1}>{collection.owner?.nickname}</Element> {hideOwner}
          </Element>
        )}
      </div>
    </InternalLink>
  );
};

export default CollectionCard;
